var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.3497 22.0002C17.138 22.0002 21.0197 18.1185 21.0197 13.3302C21.0197 8.54185 17.138 4.66016 12.3497 4.66016C7.56138 4.66016 3.67969 8.54185 3.67969 13.3302C3.67969 18.1185 7.56138 22.0002 12.3497 22.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 13.75C11.9416 13.75 11.6016 13.41 11.6016 13V8C11.6016 7.59 11.9416 7.25 12.3516 7.25C12.7616 7.25 13.1016 7.59 13.1016 8V13C13.1016 13.41 12.7616 13.75 12.3516 13.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2422 3.45H9.46219C9.06219 3.45 8.74219 3.13 8.74219 2.73C8.74219 2.33 9.06219 2 9.46219 2H15.2422C15.6422 2 15.9622 2.32 15.9622 2.72C15.9622 3.12 15.6422 3.45 15.2422 3.45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.ab5f06cad34f6a10a1b19f583203b184.svg";
export { ForwardRef as ReactComponent };